/**
 * Create/edit form for adjustment reasons. Label is fixed to "Otro" (other).
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Button, Card, CardBody, Col, Form, FormGroup, Input, Row } from 'reactstrap';

import {
  ADJUSTMENT_REASON_LABEL,
  countryOptions,
  labelOptions,
  roleScopeOptions,
  scopeOptions,
  typeOptions,
} from '../constants';
import { getOptionLabel } from '../formHelpers';

const FormCard = ({
  form,
  isEditing,
  isSaving,
  authToken,
  onFormChange,
  onSubmit,
  onCancelEdit,
}) => (
  <Card className="mb-4">
    <CardBody>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">{isEditing ? 'Editar motivo' : 'Crear motivo'}</h4>
        {isEditing && (
          <Button color="secondary" size="sm" type="button" onClick={onCancelEdit}>
            Cancelar edicion
          </Button>
        )}
      </div>
      <Form>
        <Row>
          <Col md="4">
            <FormGroup>
              <label className="form-control-label">Pais *</label>
              <Input
                type="select"
                value={form.country}
                onChange={(event) => onFormChange('country', event.target.value)}
              >
                <option value="" disabled>Seleccione pais</option>
                {countryOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          <Col md="4">
            <FormGroup>
              <label className="form-control-label">Label *</label>
              <Input
                type="text"
                value={getOptionLabel(labelOptions, ADJUSTMENT_REASON_LABEL)}
                disabled
              />
            </FormGroup>
          </Col>
          <Col md="4">
            <FormGroup>
              <label className="form-control-label">Tipo *</label>
              <Input
                type="select"
                value={form.type}
                onChange={(event) => onFormChange('type', event.target.value)}
              >
                <option value="" disabled>Seleccione tipo</option>
                {typeOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md="4">
            <FormGroup>
              <label className="form-control-label">Scope *</label>
              <Input
                type="select"
                value={form.scope}
                onChange={(event) => onFormChange('scope', event.target.value)}
              >
                <option value="" disabled>Seleccione scope</option>
                {scopeOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          <Col md="4">
            <FormGroup>
              <label className="form-control-label">Rol *</label>
              <Input
                type="select"
                value={form.role_scope}
                onChange={(event) => onFormChange('role_scope', event.target.value)}
              >
                <option value="" disabled>Seleccione rol</option>
                {roleScopeOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          <Col md="4">
            <FormGroup>
              <label className="form-control-label">Descripcion *</label>
              <Input
                type="text"
                value={form.description}
                onChange={(event) => onFormChange('description', event.target.value)}
                placeholder="Motivo visible para el usuario"
              />
            </FormGroup>
          </Col>
        </Row>
        <Button
          color="primary"
          type="button"
          onClick={onSubmit}
          disabled={isSaving || !authToken}
        >
          {isSaving ? 'Guardando...' : 'Guardar motivo'}
        </Button>
      </Form>
    </CardBody>
  </Card>
);

FormCard.propTypes = {
  form: PropTypes.shape({
    country: PropTypes.string,
    type: PropTypes.string,
    scope: PropTypes.string,
    role_scope: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
  isEditing: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool.isRequired,
  authToken: PropTypes.string,
  onFormChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancelEdit: PropTypes.func.isRequired,
};

export default FormCard;
